import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";

export class LinkControlOptions extends PDFControlBaseOptions{
    @observable
    Type:ControlTypeEnum.Link;
    @observable
    Text:string;
    @observable
    URL:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Text='Click here';
        this.URL='http://example.com';
        this.Type=ControlTypeEnum.Link;
    }
}